declare const posthog: any;
import Swiper from 'swiper';
import { getCreditUnionGroups } from './posthog-group'
import { Navigation, Pagination, Thumbs } from 'swiper/modules';

if (window.location.pathname.indexOf('/details/') > -1) {
    var swiper = new Swiper(".mySwiper", {
        modules: [Navigation, Pagination, Thumbs],
        loop: true,
        spaceBetween: 10,
        slidesPerView: 4,
        slidesPerGroup: 4,
        freeMode: true,
        watchSlidesProgress: true,
        navigation: {
            nextEl: ".sbn",
            prevEl: ".sbp",
        },
    });

    new Swiper(".mySwiper2", {
        modules: [Navigation, Pagination, Thumbs],
        loop: true,
        spaceBetween: 10,
        navigation: {
            nextEl: ".sbn",
            prevEl: ".sbp",
        },
        thumbs: {
            swiper: swiper,
        },
        on: {
            slideChange: function(swiperInstance: any) {
                if (typeof posthog !== 'undefined') {
                    const vehicleId = document.querySelector('[data-inventoryvehicleid]')?.getAttribute('data-inventoryvehicleid');
                    posthog.capture('vehicle_photo_swiped', {
                        vehicle_id: vehicleId ?? undefined,
                        photo_index: swiperInstance.realIndex,
                        total_photos: swiperInstance.slides.length,
                        $groups: getCreditUnionGroups(),
                    });
                }
            }
        }
    })
}